import { NoPermissionState } from "@/components/common/no-permission-state";
import { isForbiddenError } from "@/lib/clinic-grants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/ui/page-header";
import {
  ContainerHeader,
  FormProcedure,
  ProcedureDataTable,
} from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useFetchProceduresQuery, usePermission } from "@/hooks";
import { Skeleton } from "@/components/ui/skeleton";
import { useNavigate, useSearchParams } from "react-router-dom";

export function Procedures() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { checkPermission } = usePermission();

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const [search, setSearch] = useState<string>("");

  const {
    error: listError,
    data: proceduresData,
    isLoading,
    refetch,
  } = useFetchProceduresQuery({ search, page: page || "1" });

  useEffect(() => {

    if (!checkPermission("procedure", "view procedure")) {
      navigate("/")
      return;
    }

    setTimeout(() => {
      refetch();
    }, 1500);
  }, [search, refetch]);

  // SEC-GATES-02: a refusal from the list endpoint is stated, not shown as an empty list.
  if (isForbiddenError(listError)) return <NoPermissionState />;

  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <PageHeader
          eyebrow="Clínica"
          title={t("LABEL.procedures")}
          lede="O que a clínica oferece e quanto custa cada procedimento."
          actions={
            <FormProcedure>
              <Button variant="petrol" size="lg" className="px-5">
                {t("LABEL.new")}
              </Button>
            </FormProcedure>
          }
        />
        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar procedimentos"
            placeholder="Pesquisar"
            showError={false}
          />
        </ContainerHeader>
      </div>
      <div className="space-y-2">
        {!proceduresData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : (
          <ProcedureDataTable data={proceduresData} />
        )}
      </div>
    </section>
  );
}
